import { create } from "zustand";

interface AuthState {
  authEmail: string;
  authPhoneNumber: string;
  phoneNumberVerification: boolean;
  setAuthEmail: (authEmail: string) => void;
  setAuthPhoneNumber: (authPhoneNumber: string) => void;
  setPhoneNumberVerification: (phoneNumberVerification: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  authEmail: "",
  authPhoneNumber: "",
  phoneNumberVerification: false,
  setAuthEmail: (authEmail: string) => set({ authEmail }),
  setAuthPhoneNumber: (authPhoneNumber: string) => set({ authPhoneNumber }),
  setPhoneNumberVerification: (phoneNumberVerification: boolean) =>
    set({ phoneNumberVerification }),
}));
